import { MUICheckBox } from "@abb/arcadia-ui-react"
import { MouseEvent, useCallback, useMemo, useState } from "react"
import { useDeleteConfirm } from "../../../../hooks/useDeleteConfirm"
import { useFiles } from "../../../../hooks/useFiles"
import { DimaFeatureShortNameEnum } from "../../../models/Authorization"
import { FileGet } from "../../../models/File"
import { deleteEntity } from "../../../utils/deleteEntity"
import {
  dateStringComparator,
  getNiceFormattedDate,
} from "../../../utils/getFormattedDate"
import { DiMaAddButton } from "../../partials/DiMaAddButton"
import { EntityRow, EntityTab } from "../../partials/EntityTab"

export function Files() {
  const [getPublic, setGetPublic] = useState<boolean>(false)
  const { files, isLoadingFiles } = useFiles(getPublic)
  const { requestDelete, DeleteConfirmDialog } = useDeleteConfirm()

  const cols = [
    {
      field: "name",
      headerName: "Name",
      isLink: true,
      linkBasePath: "/files",
    },
    { field: "status", headerName: "Status" },
    { field: "owner", headerName: "Owner" },
    {
      field: "lastVersionUploadDate",
      headerName: "Last version upload date",
      sortComparator: dateStringComparator,
    },
  ]

  const sorted = [...files].sort((a, b) => (a.name ?? "").localeCompare(b.name ?? ""))

  const rows = sorted.map((file: FileGet) => ({
    id: file.id,
    name: `${file.name}.${file.extension}`,
    status: file.isPublic ? "Public" : "Private",
    owner: file.owner.username,
    lastVersionUploadDate: getNiceFormattedDate(file.lastVersion.uploadDate),
  }))

  const onChange = useCallback(() => {
    setGetPublic((getPub) => !getPub)
  }, [])

  const handleToggleIncludePublic = useCallback(
    (e: MouseEvent<HTMLElement>) => {
      e.stopPropagation()
      onChange()
    },
    [onChange]
  )

  const toolbar = useMemo(
    () => (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 16,
          width: "100%",
        }}
      >
        <MUICheckBox
          checked={getPublic}
          label="Include public files"
          size={16}
          handleToggle={handleToggleIncludePublic}
        />
        <DiMaAddButton url="/files/create" feature={DimaFeatureShortNameEnum.FM} />
      </div>
    ),
    [getPublic, handleToggleIncludePublic]
  )

  const handleActionMenuClick = useCallback(
    (item: { title: string }, row: EntityRow) => {
      if (item.title === "Delete") {
        requestDelete(() => deleteEntity(`/files/${row.id}`))
      }
    },
    [requestDelete]
  )

  return (
    <>
      {DeleteConfirmDialog}
      <EntityTab
        rows={rows}
        cols={cols}
        isLoading={isLoadingFiles}
        toolbar={toolbar}
        actionItems={[{ title: "Delete", iconName: "icon_abb_dias icon-abb_delete" }]}
        onActionMenuClick={handleActionMenuClick}
      />
    </>
  )
}
